import { Component } from '@angular/core';
import { SpotlightFooterComponent } from '../spotlight-footer/spotlight-footer.component';

@Component({
  selector: 'app-empty-spotlight-footer',
  templateUrl: './empty-spotlight-footer.component.html',
  standalone: false
})
export class EmptySpotlightFooterComponent extends SpotlightFooterComponent {}
